import React from "react";
import { Box, Typography, Button } from "@mui/joy";

interface ErrorStateProps {
  error: string | null;
  company?: string;
  onNavigateBack: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ error, company, onNavigateBack }) => {
  return (
    <Box sx={{ 
      minHeight: "100vh", 
      bgcolor: "#f4f4f4",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <Box sx={{ textAlign: "center", maxWidth: "400px", px: 2 }}>
        <Typography level="h4" sx={{ color: "#7B7F85", mb: 2 }}>
          {error || "Position not found"}
        </Typography>
        {company && (
          <Button
            variant="outlined"
            onClick={onNavigateBack}
            sx={{
              borderColor: "#2E2D7E",
              color: "#2E2D7E",
              "&:hover": {
                borderColor: "#1a1a5e",
                color: "#1a1a5e",
              },
            }}
          >
            Back to {company}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ErrorState; 